import React from 'react'
import { GetTagInstructionsContainer, CodeSpan, CopyKeyContainer } from './Instructions.styled'
import { CopyTextButton } from '@clickcease/cc-client-components-lib'
import { Trans, useTranslation } from 'react-i18next'
import { StyledLink } from 'Components/Elements/Link/Link.styled'
import { BulletLine } from '../elements/BulletLine'
import { getPluginUrl } from 'Consts/botMitigation'

export const WordpressMethod = ({
  domainHashCode,
  bzState,
  domainAddress,
}: {
  domainHashCode: string
  bzState?: number | null
  domainAddress: string | undefined
}) => {
  const { t } = useTranslation('domainManagement')

  const pluginUrl = getPluginUrl(bzState, domainAddress)
  return (
    <GetTagInstructionsContainer>
      <BulletLine>
        <Trans ns="domainManagement" i18nKey="get_tag_modal.wordpress_steps.step_1">
          Download CHEQ Essentials WordPress plugin
          <StyledLink href={pluginUrl} target="blank">
            here
          </StyledLink>
        </Trans>
      </BulletLine>
      <BulletLine
        underBullet={
          <CopyKeyContainer>
            <CodeSpan>{domainHashCode}</CodeSpan>
            <CopyTextButton value={domainHashCode} buttonText={t('get_tag_modal.copy-key')} />
          </CopyKeyContainer>
        }
      >
        {t('get_tag_modal.wordpress_steps.step_2')}
      </BulletLine>
      <BulletLine>{t('get_tag_modal.wordpress_steps.step_3')}</BulletLine>
    </GetTagInstructionsContainer>
  )
}
